// Enum para los tabs para mayor type safety
export enum TabIndex {
  LISTA = 0,
  BODY = 1,
  PREVIEW = 2,
  FILES = 3,
}
